/**
Project: Voice Panel (c)
Title: NoAccountNumber
Description: Component for displaying the No Account Number page
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import {
    Flex,
    Text,
    Segment,
    Image,
    Button,
} from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import IntlUtil from "../../core/helpers/intl-util";
import CharacterImage from "../../../assets/images/illustrations/New-SIPPIO-character-duo-2.png";
import TimerImage from "../../../assets/images/illustrations/Group_169.png";
import { AppPageTitle } from "../../core/components/app-page-title";
import SippioVoicePanelLogo from "../../../assets/images/SIPPIO-VoicePanel-Logo.png";


class NoAccountNumber extends Component {
    _intl_ns_common = "common"

    render() {
        return (
            <>
                <AppPageTitle pageTitle={IntlUtil.getText(this._intl_ns_common, "title.noAccountNumber")} />
                <div id="vpa-no-account-number">
                    <header className="vpa-no-account-number-header">
                        <Image
                            src={SippioVoicePanelLogo}
                            alt={IntlUtil.getText(
                                this._intl_ns_common,
                                "content.voicePanelBySippio"
                            )}
                            title={IntlUtil.getText(
                                this._intl_ns_common,
                                "content.voicePanelBySippio"
                            )}
                            className="vpa-image"
                        />
                    </header>
                    <div className="vpa-no-account-number-content">
                        <Grid fluid className="p-l-0 p-r-0">
                            <Row>
                                <Col xs={12} sm={12} md={8} lg={9} className="m-b-20">
                                    <Row>
                                        <Col xs={12} sm={12} md={11} lg={11} >
                                            <Row>
                                                <Col xs={12} className="m-b-10">
                                                    <Text className="vpa-title-text">
                                                        {IntlUtil.getText(this._intl_ns_common, "content.noAccountIdWelcome")}
                                                    </Text>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12}>
                                                    <Text as="p" className="vpa-text m-t-0 m-b-10 text-semibold">
                                                        {IntlUtil.getText(
                                                            this._intl_ns_common,
                                                            "content.noAccountIdSippioCaption"
                                                        )}
                                                    </Text>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} >
                                                    <Text as="p" className="vpa-text m-t-0 m-b-10">
                                                        {IntlUtil.getText(
                                                            this._intl_ns_common,
                                                            "content.noAccountIdSippioCaption1"
                                                        )}
                                                    </Text>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} >
                                                    <Text as="p" className="vpa-text m-t-0 m-b-10">
                                                        {IntlUtil.getText(
                                                            this._intl_ns_common,
                                                            "content.noAccountIdSippioCaption2"
                                                        )}
                                                    </Text>
                                                </Col>
                                            </Row>
                                            <Row between="xs">
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="m-t-15 m-b-15">
                                                    <Segment className="vpa-segment">
                                                        <Flex gap="gap.medium">
                                                            <Image src={TimerImage} alt="" className="vpa-page-image vpa-page-image-h m-20" />
                                                            <Grid fluid >
                                                                <Row>
                                                                    <Col xs={12}>
                                                                        <Text as="p" className="vpa-text m-t-0 m-b-5 text-fc-primary text-semibold">
                                                                            {IntlUtil.getText(
                                                                                this._intl_ns_common,
                                                                                "content.noAccountIdAccess"
                                                                            )}
                                                                        </Text>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col xs={12}>
                                                                        <Text as="p" className="vpa-text m-t-0 m-b-5 text-semibold">
                                                                            {IntlUtil.getText(
                                                                                this._intl_ns_common,
                                                                                "content.noAccountIdActivate"
                                                                            )}
                                                                        </Text>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col xs={12} >
                                                                        <Text as="p" className="vpa-text m-t-0 m-b-5">
                                                                            {IntlUtil.getText(
                                                                                this._intl_ns_common,
                                                                                "content.noAccountIdActivate1"
                                                                            )}
                                                                        </Text>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col xs={12} className="m-b-10 m-t-10">
                                                                        <a
                                                                            rel="noopener noreferrer"
                                                                            target="_blank"
                                                                            href="https://www.sippio.io/contact/">
                                                                            <Button primary
                                                                                content={
                                                                                    <Text >
                                                                                        {IntlUtil.getText(
                                                                                            this._intl_ns_common,
                                                                                            "content.contactUS"
                                                                                        )}
                                                                                    </Text>
                                                                                } />
                                                                        </a>
                                                                    </Col>
                                                                </Row>
                                                            </Grid>
                                                        </Flex>
                                                    </Segment>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={3} className="m-b-10 m-t-20">
                                    <Image src={CharacterImage} alt="" className="vpa-page-image" />
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </div>
            </>
        )
    }

}

export default NoAccountNumber